import React from 'react';
import { observer, inject } from 'mobx-react';
import { getUrlParams } from 'common/utils/routing.util';
import { TransactionStatus } from 'Components/TransactionStatus/TransactionStatus';
import Spinner, { SpinnerOverlayContent } from 'Components/Spinner/Spinner';
import routes from '../../common/constants/routing.constants';

class Signed extends React.Component {
  state = {
    urlParams: getUrlParams() || {},
    hasTransactionStatusProvided: false,
    binomEventSent: false,
  };

  authToken() {
    return this.props.AuthStore.authToken;
  }

  hasTransactionStatusProvided() {
    const { amount, currency, status } = this.state.urlParams;
    return !!amount || !!status || !!currency;
  }

  withOAuthProvider() {
    return !!this.state.urlParams?.oauth_provider;
  }

  onAuth() {
    if (!this.state.binomEventSent) {
      this.setState({ binomEventSent: true });
      this.sendMsg(`rw_done:${this.authToken()}`);
    }
  }

  sendMsg(data) {
    try {
      console.log('sending event', data);
      window.parent.postMessage(data, '*');
    } catch (error) {
      console.log(error, 'iframe msg err');
    }
  }

  render() {
    if (this.withOAuthProvider()) {
      window.location.pathname = routes.root.path;
    }
    if (!this.hasTransactionStatusProvided()) {
      this.onAuth();
      return (
        <SpinnerOverlayContent>
          <Spinner />
        </SpinnerOverlayContent>
      );
    }

    if (this.hasTransactionStatusProvided()) {
      this.props.AppStore.sendCloseCrossTabEvent();
      if (window.opener) {
        window.opener.close();
      }
    }

    return (
      <div>
        <TransactionStatus data={this.state.urlParams} />
      </div>
    );
  }
}

export const SignedWithAuth = inject('AuthStore', 'AppStore')(observer(Signed));
